import "./style.css";

export default class Label {
  static selector = ".label";

  constructor(block) {
    this.block = block;
  }
}
